export default "__VITE_ASSET__f71e43a6__"